<template>
  <v-menu
    :close-on-content-click="false"
    :max-width="250"
    :nudge-width="100"
    transition="slide-x-transition"
    v-if="userData.role_id == 3 || userData.role_id == 2"
  >
    <template v-slot:activator="{ on }">
      <v-hover v-if="mode === 'TOOLBAR'" v-slot:default="{ hover }">
        <v-btn
          icon
          small
          class="mx-1"
          :color="
            hover ? 'secondary' : isDark ? 'blue-grey darken-1' : 'blue-grey'
          "
          v-on="on"
        >
          <v-icon>mdi-coffee</v-icon>
        </v-btn>
      </v-hover>
      <template v-if="mode === 'HOME'">
        <v-card
          flat
          v-on="on"
          height="100px"
          class="bg-1 d-none d-md-flex align-center"
        >
          <v-list-item>
            <v-list-item-avatar tile>
              <img src="@/assets/images/home-buttons/2.png" alt="icon" />
            </v-list-item-avatar>

            <v-list-item-content class="white--text text-uppercase">
              <v-list-item-title>Pausas</v-list-item-title>

              <!-- <v-list-item-subtitle class="text-caption white--text">
                  Día / Mes / Año
                </v-list-item-subtitle> -->
            </v-list-item-content>
          </v-list-item>
        </v-card>

        <v-card v-on="on" flat class="bg-4 d-flex d-md-none text-center">
          <v-responsive aspect-ratio="1" class="align-center">
            <v-avatar tile>
              <img src="@/assets/images/home-buttons/2.png" alt="icon" />
            </v-avatar>
            <v-list-item>
              <v-list-item-content class="white--text text-uppercase">
                <v-list-item-title>Pausas</v-list-item-title>

                <!-- <v-list-item-subtitle class="text-caption white--text">
                    Creados
                  </v-list-item-subtitle> -->
              </v-list-item-content>
            </v-list-item>
          </v-responsive>
        </v-card>
      </template>
    </template>

    <v-card>
      <v-list class="py-0">
        <v-list-item>
          <v-list-item-title class="font-weight-medium">
            Pausas disponibles
          </v-list-item-title>
        </v-list-item>
      </v-list>

      <v-text-field
        class="mx-2"
        filled
        rounded
        dense
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>

      <div style="max-height: 400px">
        <v-list>
          <v-data-iterator
            :items="Breaks"
            :search="search"
            sort-by="name"
            hide-default-footer
            :items-per-page="-1"
          >
            <template v-slot:default="props">
              <v-list-item
                v-for="(item, index) in props.items"
                :key="index"
                @click="agentBreak(item)"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle>
                    {{ item.time }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-avatar
                  :color="isDark ? 'grey darken-3' : 'grey lighten-3'"
                  size="30"
                >
                  <span class="font-weight-medium secondary--text">
                    {{ item.quantity }}
                  </span>
                </v-list-item-avatar>
              </v-list-item>
            </template>
          </v-data-iterator>
        </v-list>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: "TOOLBAR",
    },
  },

  data: () => ({
    search: "",
    userData: {},
  }),

  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },

    ProfileInfo() {
      return this.$store.getters["passport/CURRENT_USER"];
    },

    Breaks() {
      return this.$store.getters["breaks/GET_ALL_BREAKS"];
    },

    hasRTC() {
      return !!this.ProfileInfo.web_rtc;
    },
  },

  mounted() {
    this.userData = JSON.parse(localStorage.getItem("user"));
  },

  methods: {
    async agentBreak(item) {
      try {
        const confirmRequest = await this.$swalconfirm(
          item.name,
          "¿Desea comenzar esta pausa?"
        );
        if (confirmRequest.isConfirmed) {
          this.$store.commit("layout/SET_OVERLAY", {
            value: true,
            title: "Pausa en proceso",
          });
          await this.handleStartBreak(item.id);
        }
      } catch (error) {
        this.$snotify.error("No se pudo iniciar la pausa.", "¡Error!");
        console.error("PAUSA", error);
      }
    },
    async handleStartBreak(breakId) {
      if (this.ProfileInfo.connect)
        await await this.$store.dispatch("passport/DISCONNECT_QUEUES");
      if (this.hasRTC)
        setTimeout(() => {
          this.$store.dispatch("dialer/SET_IS_CONNECTED", true);
        }, 5000);

      setTimeout(async () => {
        await this.$store.dispatch("breaks/USE_BREAK", {
          pause_id: breakId,
        });
        this.$store.commit("layout/SET_OVERLAY", { value: false, title: "" });
      }, 5000);
    },
  },
};
</script>

